import { blockType } from "../constants";
import { TableBlockSchema } from "../schema";
import type { Table } from "../types";

export const create: Table["create"] = (initialConfig) => {
  return TableBlockSchema.parse({
    type: blockType,
    config: {
      ...initialConfig,
      title: initialConfig?.title || "My table",
      canSearchRecords: true,
      canCreateRecords: true,
      canUpdateRecords: true,
      canDeleteRecords: false,
      style: {
        width: "wide",
        alignment: "center",
      },
    },
  });
};
